/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Status_ServicesInputs */



/**
* | output |
* | --- |
* | "Services" |
*
* @param {Offline_Status_ServicesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_status_services = /** @type {((inputs?: Offline_Status_ServicesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Status_ServicesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Services")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dienstleistungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Servizi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Услуги")
	if (locale === "es") return /** @type {LocalizedString} */ ("Servicios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("服务")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サービス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेवाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Serviços")
	return /** @type {LocalizedString} */ ("Services")
});